import { useEffect, useState } from "react";

const isMobileCheck = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 1199px)").matches;
};

export function useMobile() {
  const [isMobile, setIsMobile] = useState(isMobileCheck());

  useEffect(() => {
    function windowResize() {
      setIsMobile(isMobileCheck());
    }

    windowResize();
    window.addEventListener("resize", windowResize);
    return () => window.removeEventListener("resize", windowResize);
  }, []);

  return isMobile;
}
